import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ReactComponent as MoreIcon } from "../../assets/images/MoreSquare1.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllOrganisation,
  getIndustryMaster,
  getTypeMaster,
} from "../../reduxSlices/organisationSlice";
import { VF_ADMIN_ROLE_ID, toastConfig } from "../../constants/constant";
import { setHeader } from "../../reduxSlices/headerSlice";
import ContentLoader from "../../components/loader/ContentLoader";
import debounce from "lodash.debounce";
import { useCallback } from "react";
import TopBar from "../../components/topbar/TopBar";
import ActionDropdown from "../../components/dropdown/ActionDropdown";
import { Service } from "../../services/service";
import { toast } from "react-toastify";
import NoResultFound from "../../components/noResultFound/NoResultFound";
import { getUserLogin } from "../../reduxSlices/userSlice";
import { getPackageMaster } from "../../reduxSlices/packageSlice";

const service = new Service();

const columns = [
  { id: "name", label: "Name", minWidth: 170, align: "left" },
  { id: "type", label: "Type", minWidth: 170, align: "left" },
  {
    id: "industry",
    label: "Industry",
    minWidth: 170,
    align: "left",
  },
  {
    id: "users",
    label: "Users",
    minWidth: 170,
    align: "left",
  },
  {
    id: "pkg",
    label: "Packages",
    minWidth: 170,
    align: "left",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 170,
    align: "left",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 100,
    align: "center",
  },
];

export default function OrganisationPage() {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [id, setId] = useState(null);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const allOrganisation = useSelector(
    (state) => state.organization.allOrganisation
  );
  const loading = useSelector((state) => state.organization.loading);
  const headerData = useSelector((state) => state.header);
  const searchInput = headerData.searchInput;
  const typeValue = headerData.typeValue;
  const industryValue = headerData.industryValue;
  const packageValue = headerData.packageValue;
  const userRole = useSelector((state) => state?.user?.userRoleId);
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID) ? true : false;
  const userData = useSelector((state) => state?.user);
  const userEmailId = userData?.emailId;
  const packageMaster = useSelector((state) => state?.package?.packageMaster);
  const packageOptions = packageMaster?.map((item, i) => item?.packageName);
  const typeMaster = useSelector((state) => state?.organization?.typeMaster);
  const typeOptions = typeMaster?.map((item, i) => item?.name);
  const industryMaster = useSelector(
    (state) => state?.organization?.industryMaster
  );
  const industryOptions = industryMaster?.map((item, i) => item?.name);

  const getOrganisationData = async () => {
    const obj = {
      searchText: searchInput || "",
      organizationType: typeValue || [],
      industry: industryValue || [],
      package: packageValue || [],
    };
    await dispatch(getAllOrganisation(obj));
  };

  const fetchUserLogin = async () => {
    const obj = {
      email: userEmailId,
    };
    await dispatch(getUserLogin(obj));
  };

  const handleMoreIcon = (event, data) => {
    console.log("event", event);
    setAnchorEl(event.currentTarget);
    setId(data?.organizationId);
    setData(data);
  };

  useEffect(() => {
    dispatch(
      setHeader({
        page: "organisations",
        title: "Organisations",
        subTitle:
          "Here is the list of all organisations along with their details",
      })
    );
    dispatch(getTypeMaster());
    dispatch(getIndustryMaster());
    dispatch(getPackageMaster());
  }, []);

  useEffect(() => {
    getOrganisationData();
  }, [dispatch]);

  const getOrganisationDataWithDebounce = debounce(() => {
    getOrganisationData();
  }, 500);

  const typeValueDebounceLoadData = useCallback(
    debounce(getOrganisationDataWithDebounce, 500),
    [typeValue]
  );
  const industryValueDebounceLoadData = useCallback(
    debounce(getOrganisationDataWithDebounce, 500),
    [industryValue]
  );
  const packageValueDebounceLoadData = useCallback(
    debounce(getOrganisationDataWithDebounce, 500),
    [packageValue]
  );

  const searchInputDebounceLoadData = useCallback(
    debounce(getOrganisationDataWithDebounce, 500),
    [searchInput]
  );

  useEffect(() => {
    searchInputDebounceLoadData();

    return searchInputDebounceLoadData.cancel;
  }, [searchInput, searchInputDebounceLoadData]);

  useEffect(() => {
    typeValueDebounceLoadData();

    return typeValueDebounceLoadData.cancel;
  }, [typeValue, typeValueDebounceLoadData]);

  useEffect(() => {
    industryValueDebounceLoadData();

    return industryValueDebounceLoadData.cancel;
  }, [industryValue, industryValueDebounceLoadData]);

  useEffect(() => {
    packageValueDebounceLoadData();

    return packageValueDebounceLoadData.cancel;
  }, [packageValue, packageValueDebounceLoadData]);

  const handleDelete = () => {
    if (id) {
      console.log("id>>>>>>>", id);
      deleteOrganisation(id);
      setOpen(false);
    }
  };

  const deleteOrganisation = async (id) => {
    let url = `/api/Organization/DeleteOrganization?id=${id}`;
    const user_token = localStorage.getItem("bb_access_token");
    try {
      let response = await service.newDeleteApi(url, {}, user_token);
      let resp = response?.data;
      console.log("resp", resp);
      if (resp?.data && resp?.success) {
        toast.success(
          `Organisation marked as ${data?.isActive ? "Inactive" : "Active"}`,
          {
            ...toastConfig,
            style: {
              backgroundColor: "#4a67ad",
            },
          }
        );
        getOrganisationData();
        fetchUserLogin();
      } else {
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.message, toastConfig);
    }
  };

  return (
    <>
      <Paper
        style={{
          width: "100%",
          overflow: "hidden",
          border: "none",
          borderRadius: "12px",
          boxShadow: "none",
          paddingBottom: "32px",
        }}
      >
        <TopBar
          isVfAdmin={isVfAdmin}
          typeFilter={typeOptions}
          industryFilter={industryOptions}
          packageFilter={packageOptions}
          placeholder="Search organisations here..."
        />
        {loading && allOrganisation.length <= 0 ? (
          <ContentLoader />
        ) : (
          <TableContainer
            style={{ maxHeight: "calc(100vh - 320px)", padding: "0 0" }}
            className="table_container"
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns?.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        backgroundColor: "#fff",
                        color: "#8a8a8a",
                        fontFamily: "Montserrat",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {allOrganisation.length > 0 ? (
                  <>
                    {allOrganisation?.map((elem) => (
                      <TableRow hover key={elem.organizationId}>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            color: "#282828",
                            fontWeight: 600,
                          }}
                        >
                          {elem?.organizationName || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.organizationType || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.industry || ""}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.users?.length || 0} Users
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.packages?.length || 0} Packages
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            fontWeight: 500,
                          }}
                        >
                          {elem?.isActive ? "Active" : "Inactive"}
                        </TableCell>
                        <TableCell
                          style={{
                            borderColor: "#f2f4f9",
                            fontFamily: "Montserrat",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          align="center"
                        >
                          <MoreIcon onClick={(e) => handleMoreIcon(e, elem)} />
                        </TableCell>
                      </TableRow>
                    ))}
                    <ActionDropdown
                      anchorEl={anchorEl}
                      setAnchorEl={setAnchorEl}
                      editNavigate={`/edit-organisation/${id}`}
                      setOpen={setOpen}
                      isDelete={false}
                      isActive={true}
                      text={`Mark as ${data?.isActive ? "Inactive" : "Active"}`}
                      markAsActiveInactive={handleDelete}
                    />
                  </>
                ) : (
                  <NoResultFound
                    description="We couldn’t find any matches for search query or applied filter. Please try different
                  keyword or filters."
                  />
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </>
  );
}
